var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { on: { mouseover: _vm.onOver, mouseleave: _vm.onLeave } },
    [
      _c(
        "b-dropdown",
        {
          ref: "dropdown",
          attrs: {
            text: _vm.text,
            variant: _vm.variant,
            "toggle-class": _vm.toggleClass,
            "menu-class": _vm.menuClass,
            dropleft: _vm.dropLeft,
          },
        },
        _vm._l(_vm.BOARDS, function (ref) {
          var name = ref.name
          var owner = ref.owner
          var ownerDetails = ref.ownerDetails
          var isDefault = ref.default
          var id = ref.id
          var numberOfClients = ref.numberOfClients
          return _c(
            "b-dropdown-item",
            {
              key: id,
              staticClass: "board-link clickable",
              attrs: {
                href: !_vm.update ? _vm.getHref() : null,
                disabled: _vm.boardId === id,
              },
              on: {
                click: function ($event) {
                  return _vm.transferProfile(id, $event)
                },
              },
            },
            [
              _c("span", { staticClass: "bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(name) +
                    " " +
                    _vm._s(
                      isDefault && owner ? _vm.$t("global.words.default") : ""
                    ) +
                    "\n        " +
                    _vm._s(
                      _vm.boardId === id
                        ? "- " + _vm.$t("global.words.selected")
                        : ""
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("boards.messages.boardOwner")) +
                    ": " +
                    _vm._s(ownerDetails.givenName) +
                    "\n        " +
                    _vm._s(ownerDetails.familyName) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(numberOfClients) +
                    "\n        " +
                    _vm._s(
                      _vm.$tc("global.doorr.client", parseInt(numberOfClients))
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              !_vm.update
                ? _c(
                    "a",
                    {
                      staticClass:
                        "dropdown-item create-new-board pl-4 mb-1 p-2",
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#create-new-board-modal",
                        href: "#",
                      },
                    },
                    [
                      _c("span", { staticClass: "oblique" }, [
                        _vm._v(_vm._s(_vm.$t("boards.actions.createNewBoard"))),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("span"),
                    ]
                  )
                : _vm._e(),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }